<template>
  <v-container class="px-0 my-lg-3">
    <v-row>
      <v-col class="v-col-12 v-col-lg-8" :order="mobile == false ? 1 : 2">
        <v-row class="me-lg-1 bg-white pb-3 px-3 px-lg-0 mt-2 mt-lg-0">
          <v-col class="v-col-12 v-col-lg-10 offset-lg-1 d-flex justify-center">
            <v-timeline direction="horizontal" truncate-line="both" class="checkout-timeline justify-center">
              <v-timeline-item fill-dot :size="mobile == false ? '65px' : '50px'" :class="step.one" class="cursor-pointer" @click="jumpStep(1)">
                <template v-slot:opposite>
                  <span class="font-weight-bold" :class="mobile == false ? '' : 'text-xsmall'">Agendamento</span>
                </template>
                <template v-slot:icon>
                  <span class="font-weight-bold text-xlarge">1</span>
                </template>
              </v-timeline-item>
              <v-timeline-item fill-dot :size="mobile == false ? '65px' : '50px'" :class="step.two" class="cursor-pointer" @click="jumpStep(2)">
                <span class="font-weight-bold" :class="mobile == false ? '' : 'text-xsmall'">&nbsp;&nbsp;Produtos&nbsp;</span>
                <template v-slot:icon>
                  <span class="font-weight-bold text-xlarge">2</span>
                </template>
              </v-timeline-item>
              <v-timeline-item fill-dot :size="mobile == false ? '65px' : '50px'" :class="step.three" class="cursor-pointer" @click="jumpStep(3)">
                <template v-slot:opposite>
                  <span class="font-weight-bold" :class="mobile == false ? '' : 'text-xsmall'">&nbsp;&nbsp;Pagamento&nbsp;</span>
                </template>
                <template v-slot:icon>
                  <span class="font-weight-bold text-xlarge">3</span>
                </template>
              </v-timeline-item>
              <v-timeline-item fill-dot :size="mobile == false ? '65px' : '50px'" :class="step.four" class="cursor-pointer">
                <span class="font-weight-bold" :class="mobile == false ? '' : 'text-xsmall'">&nbsp;&nbsp;Revisão&nbsp;&nbsp;</span>
                <template v-slot:icon>
                  <span class="font-weight-bold text-xlarge">4</span>
                </template>
              </v-timeline-item>
            </v-timeline>
          </v-col>
          <v-col cols="12">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-12 v-col-lg-10 offset-lg-1">
            <v-row v-if="step.value == 1">
              <v-col cols="12">
                <span class="text-color-0 text-large font-weight-bold">1. Confirme a opção selecionada</span>
              </v-col>
              <v-col cols="12">
                <v-skeleton-loader :loading="loadingUser" type="image" width="100%" height="150px">
                  <v-card class="border br-10 w-100" variant="outlined">
                    <template v-slot:title>
                      <div class="w-100 d-flex justify-space-between">
                        <h3 class="text-color-1">
                          {{ getSelectedAddress.destiny_type ? 'ENTREGA': 'RETIRADA' }}
                        </h3>
                        <div>
                          <v-btn v-if="getSelectedAddress.destiny_type >= 1" class="bg-color-green text-color-white me-2 d-none d-sm-inline" variant="flat" @click="newAddress()">Novo</v-btn>
                          <v-btn class="bg-color-2 text-color-white" variant="flat" @click="startIsEntrega = getSelectedAddress.destiny_type; modelAddress = !modelAddress">Alterar</v-btn>
                          <v-btn class="bg-color-1 text-color-white ms-2 d-none d-sm-inline" variant="flat" @click="startIsEntrega = 0; modelAddress = !modelAddress" v-if="getConfig.storeConfig.min_withdrawal_value_order >= 0 && getSelectedAddress.destiny_type >= 1">Retirada</v-btn>
                          <v-btn class="bg-color-1 text-color-white ms-2 d-none d-sm-inline" variant="flat" @click="startIsEntrega = 1; modelAddress = !modelAddress" v-if="getConfig.storeConfig.min_delivery_value_order >= 0 && getSelectedAddress.destiny_type == 0">Entrega</v-btn>
                        </div>
                      </div>
                    </template>
                    <template v-slot:prepend>
                      <Svgs v-if="getSelectedAddress.destiny_type" :icon="'house'" :color="'fill-color-1'" :height="30" :width="30"></Svgs>
                      <Svgs v-else :icon="'market'" :color="'fill-color-1'" :height="30" :width="30"></Svgs>
                    </template>
                    <v-card-text class="text-color-0">
                      <b v-if="getSelectedAddress.address_nickname != ''">{{ getSelectedAddress.address_nickname }}</b><br>
                      {{ getSelectedAddress.street }}, {{ getSelectedAddress.num }} - {{ getSelectedAddress.district }} - {{ getSelectedAddress.city }} - {{ getSelectedAddress.state }}<br>
                      <b>CEP:</b> {{ getSelectedAddress.zip_code }}<br>
                      <b v-if="getSelectedAddress.complement != ''">Complemento:</b> {{ getSelectedAddress.complement }}
                    </v-card-text>
                  </v-card>
                </v-skeleton-loader>
              </v-col>
              <v-col cols="12" class="text-center text-color-red" v-if="getSelectedAddress.destiny_type >= 1 && getSelectedAddress.area == null">
                <v-alert variant="tonal" class="alert-custom-red">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-alert-outline" class="text-color-red" size="x-large"></v-icon>
                  </template>
                  <span>
                    Infelizmente não efetuamos entrega para este endereço. Por favor, verifique se o endereço está
                  </span>
                  <span v-if="getConfig.storeConfig.min_withdrawal_value_order >= 0">
                    correto ou retire suas compras em nossa unidade.
                  </span>
                  <span v-else>correto.</span>
                </v-alert>
              </v-col>
              <v-col cols="12" class="text-center text-color-red" v-else-if="getSelectedAddress.destiny_type == 0 && getConfig != null && getConfig.storeConfig != null && getConfig.storeConfig.min_withdrawal_value_order < 0">
                <v-alert variant="tonal" class="alert-custom-red">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-alert-outline" class="text-color-red" size="x-large"></v-icon>
                  </template>
                  <span>
                    Infelizmente não efetuamos retirada nesta unidade. 
                    Por favor, altere para um endereço de entrega.
                  </span>
                </v-alert>
              </v-col>
              <v-col cols="12" v-else>
                <span class="text-color-0 text-large font-weight-bold">2. Agende o dia e horário</span>
              </v-col>
              <v-col v-if="getConfig.storeConfig != null && getConfig.storeConfig.min_express_value_order >= 0 && getSelectedAddress.area != null && getSelectedAddress.area.express != null && getSelectedAddress.area.express.is_able == 1" cols="12">
                <v-radio-group v-model="opt_express" :hide-details="true" class="text-color-0">
                  <v-radio class="border rounded py-1" value="1" :class="opt_express == '1' ? 'text-color-1 border-color-1':''">
                    <template v-slot:label>
                      <span>Entrega Express - até <span class="font-weight-bold text-color-1">&nbsp;{{ getConfig.storeConfig.max_qtd_items_express }} itens&nbsp;</span> em no máximo {{ formatTime(getSelectedAddress.area.express.estimated_time) }}.</span>
                    </template>
                  </v-radio>
                  <v-radio class="border rounded py-1 mt-2" label="Entrega Agendada" value="0" :class="opt_express == '0' ? 'text-color-1 border-color-1':''"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col v-if="opt_express == '0' && ((getSelectedAddress.destiny_type == 0 && getConfig != null && getConfig.storeConfig != null && getConfig.storeConfig.min_withdrawal_value_order >= 0) || getSelectedAddress.area != null)" cols="1" class="d-flex align-center justify-center">
                <v-btn @click="prev" icon="mdi-chevron-left" variant="plain" flat :color="'var(--color-one)'"></v-btn>
              </v-col>
              <v-col cols="10" class="d-flex align-center justify-center" v-if="opt_express == '0' && allowedDates != null && allowedDates.length > 0">
                <Carousel ref="carousel" :itemsToShow="mobile == false ? 7 : 5" :itemsToScroll="mobile == false ? 7 : 5" snapAlign="start" v-if="loadingTimes == false" class="carousel-hours">
                  <Slide v-for="d in allowedDates" v-bind:key="d">
                    <div :class="d.disabled == true ? 'hour-item-disabled' : (d.data.split(' ')[0] == dt_delivery ? 'hour-item bg-color-1 text-color-white' : 'hour-item text-color-0')"  @click="dt_delivery = d.disabled == true ? dt_delivery : d.data.split(' ')[0]">
                      <span><small>{{ month(toDate(d.data).getMonth()) }}</small><br>
                      <b class="text-large">{{ weekday(toDate(d.data).getDay()) }}<br>
                      {{ toDate(d.data).getDate() }}</b></span>
                    </div>
                  </Slide>
                </Carousel>
              </v-col>
              <v-col cols="10" class="d-flex align-center justify-center text-color-0" v-else-if="opt_express == '0' && ((getSelectedAddress.destiny_type == 0 && getConfig != null && getConfig.storeConfig != null && getConfig.storeConfig.min_withdrawal_value_order >= 0) || getSelectedAddress.area != null)">
                Nenhum dia disponível para essa opção.
              </v-col>
              <v-col v-if="opt_express == '0' && ((getSelectedAddress.destiny_type == 0 && getConfig != null && getConfig.storeConfig != null && getConfig.storeConfig.min_withdrawal_value_order >= 0) || getSelectedAddress.area != null)" cols="1" class="d-flex align-center justify-center">
                <v-btn @click="next" icon="mdi-chevron-right" variant="plain" flat :color="'var(--color-one)'"></v-btn>
              </v-col>
              <v-col cols="12" v-if="opt_express == '0' && allowedTimes.length > 0">
                <div class="hour_list">
                  <v-radio-group v-model="hr_delivery">
                  <v-list>
                    <v-list-item v-for="h in allowedTimes" v-bind:key="h" :ripple="false" variant="outlined" class="br-5 mb-2 ps-0" @click="hr_delivery = h.value" :active="hr_delivery == h.value">
                      <div class="w-100 d-flex justify-space-between align-center text-color-0">
                        <v-radio :value="h.value" :label="h.title" :class="hr_delivery == h.value ? 'text-color-1' : ''"></v-radio>
                        <v-icon icon="mdi mdi-check" class="text-color-1" v-if="hr_delivery == h.value"></v-icon>
                        <v-btn flat size="small" color="var(--color-one)" class="btn-selecionar text-color-white br-5" v-else>Selecionar</v-btn>
                      </div>
                    </v-list-item>
                  </v-list>
                  </v-radio-group>
                  <div class="white-blur"></div>
                </div>
              </v-col>
              <v-col cols="12" v-if="getSelectedAddress.destiny_type >= 1 && getSelectedAddress.area != null">
                <v-card variant="outlined" class="border-color-gray">
                  <v-card-text class="py-0">
                    <v-checkbox density="compact" hide-details label="Desejo autorizar outra pessoa a receber o pedido" class="text-color-0" v-model="autorizacao"></v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="getSelectedAddress.destiny_type && autorizacao">
                <v-text-field variant="outlined" label="Nome completo" v-model="autorizado.res_name_withdrawal"></v-text-field>
                <v-text-field variant="outlined" label="CPF" v-model="autorizado.res_doc_withdrawal" v-maska:[masks.cpf]></v-text-field>
              </v-col>
              <v-col cols="12" v-if="(getSelectedAddress.destiny_type == 0 && getConfig != null && getConfig.storeConfig != null && getConfig.storeConfig.min_withdrawal_value_order >= 0) || getSelectedAddress.area != null">
                <v-alert variant="tonal" class="alert-custom-1">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-alert-outline" class="text-color-1" size="x-large"></v-icon>
                  </template>
                  <span class="text-small text-color-1">É obrigatório a apresentação do documento de identificação pessoal para receber o pedido. </span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row v-if="step.value == 2">
              <v-col cols="12">
                <span class="text-color-0 text-large font-weight-bold">1. Caso falte algum produto da sua compra:</span>
              </v-col>
              <v-col cols="12">
                <v-radio-group v-model="opt_missing" :hide-details="true" class="text-color-0">
                  <v-radio class="border rounded py-1" label="Substituir por produto similar e de preço semelhante" value="1" :class="opt_missing == '1' ? 'text-color-1 border-color-1':''"></v-radio>
                  <v-radio class="border rounded py-1 mt-2" label="Excluir o item da minha compra" value="2" :class="opt_missing == '2' ? 'text-color-1 border-color-1':''"></v-radio>
                  <v-radio class="border rounded py-1 mt-2" label="Desejo receber contato" value="3" :class="opt_missing == '3' ? 'text-color-1 border-color-1':''"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" v-if="opt_missing == 3">
                <v-text-field variant="outlined" label="Telefone para contato" v-model="opt_missing_obs" v-maska:[masks.phone]></v-text-field>
              </v-col>
              <v-col cols="12">
                <span class="text-color-0 text-large font-weight-bold">2. Algum comentário geral sobre seu pedido?</span>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="obs_order" variant="outlined" :hide-details="true" placeholder="Ex. carne em cubos, tomates maduros e etc."></v-textarea>
              </v-col>
              <v-col cols="12">
                <span class="text-color-0 text-large font-weight-bold">3. Lista de produtos selecionados ({{ getTotalCart }})</span>
              </v-col>
              <v-col cols="12">
                <v-list class="w-100 pa-0 ma-0" v-for="m in getItensCart" :key="m.catid">
                  <v-list-item class="bg-color-gray text-color-0 text-start py-0 rounded">{{ getCategoryById(m.catid) != undefined > 0 ? getCategoryById(m.catid).name : '' }} ({{ m.qtd }} {{ m.qtd > 1 ? ' itens':' item' }}) - {{ $formatNumber(m.total, {style: 'currency', currency: 'BRL'}) }}</v-list-item>
                  <ProductList v-for="p in m.itens" :key="p.sku" :product="p"></ProductList>
                </v-list>
              </v-col>
            </v-row>
            <v-row v-if="step.value == 3">
              <v-col cols="12">
                <span class="text-color-0 text-large font-weight-bold">1. Selecione abaixo a forma de pagamento</span>
              </v-col>
              <v-col cols="12" v-if="order.total_final == 0">
                <v-alert variant="tonal" class="alert-custom-1">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-alert-outline" class="text-color-1" size="x-large"></v-icon>
                  </template>
                  <span class="text-small text-color-1">
                    <span v-if="getSaldoCarteira - order.wallet_value > 0">
                      Na separação da sua compra o valor total poderá exceder, nesse caso o saldo da carteira digital será utilizado.<br><br>Mas para o caso de sua carteira digital não ter saldo suficiente, selecione uma forma de pagamento:
                    </span>
                    <span v-else>
                      Na separação da sua compra o valor total poderá exceder, nesse caso selecione uma forma de pagamento:
                    </span>
                  </span>
                </v-alert>
              </v-col>
              <v-col cols="12">
                <v-radio-group :hide-details="true" class="text-color-0" v-model="is_online_payment">
                  <v-radio value="1" class="border rounded py-1" v-if="getConfig.storeConfig.is_op == 1" :class="is_online_payment == '1' ? 'text-color-1 border-color-1':''">
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <Svgs :icon="'card'" :color="'fill-color-2'" :width="40" :height="40"></Svgs> 
                        <span class="ms-3">Pagamento Online - Cartão</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio value="2" class="mt-3 border rounded py-1" v-if="getConfig.storeConfig.is_pix == 1" :class="is_online_payment == '2' ? 'text-color-1 border-color-1':''">
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <Svgs :icon="'pix'" :color="'fill-color-1'" :width="40" :height="40"></Svgs> 
                        <span class="ms-3">Pagamento Online - Pix</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio v-if="getPayments().length > 0" value="0" class="mt-3 border rounded py-1" :class="is_online_payment == '0' ? 'text-color-1 border-color-1':''">
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <Svgs :icon="'money'" :color="'fill-color-green'" :width="40" :height="40"></Svgs> 
                        <span class="ms-3">Fazer o pagamento na {{ getSelectedAddress.destiny_type ? 'entrega': 'retirada' }}</span>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" v-if="is_online_payment == 1">
                <span class="text-color-0 text-large font-weight-bold">2. Informe dos dados do cartão</span>
                <v-row>
                  <v-col class="d-flex mb-1 mt-5 justify-center">
                    <CreditCard :card="card" :config="card_config"></CreditCard>
                  </v-col>
                </v-row>
                <v-form ref="payment" lazy-validation>
                  <v-row class="mt-4">
                    <v-col cols="12" class="py-0 mb-4">
                      <v-text-field variant="outlined" label="Número do cartão" v-model="card.number" v-maska:[card_config.maskNumber] :rules="[rules.required, rules.minNumber, rules.isFlagAccept]" :validate-on="'blur'" placeholder="Ex.: 0000 0000 0000 0000">
                        <template v-slot:prepend-inner>
                          <img :src="card_config.icon" :alt="card_config.name" v-if="card_config.icon != '' && card_config.icon != null && card_config.icon != undefined && card_config.icon != 'no-image'"><img v-else src="@/assets/images/indefinido.jpg">
                        </template>
                        <template v-slot:append-inner>
                          <v-icon icon="mdi-alert-outline" size="large" @click="modelPayments = true"></v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="py-0 mb-4">
                      <v-text-field variant="outlined" label="Validade" v-model="card.valid" v-maska:[card_config.maskValid] :rules="[rules.required, rules.minValid, rules.isDateValid, rules.isMonthValid]" :validate-on="'blur'" placeholder="MM/AA"></v-text-field>
                    </v-col>
                    <v-col cols="6" class="py-0 mb-4">
                      <v-text-field variant="outlined" label="Código de segurança (CVV)" v-model="card.cvv" v-maska:[card_config.maskCvv] :rules="[rules.required, rules.minCvv]" :validate-on="'blur'" placeholder="Ex.: 000" @focus="card_config.front = false" @blur="card_config.front = true"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 mb-4">
                      <v-text-field variant="outlined" label="Nome do titular" v-model="card.name" :rules="[rules.required, rules.minName]" :validate-on="'blur'" placeholder="JOAO D SILVA"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 mb-4">
                      <v-text-field variant="outlined" label="CPF/CNPJ do titular" v-model="card.doc" v-maska:[card_config.maskCpfCnpj] :rules="[rules.required, rules.minCpf]" :validate-on="'blur'" placeholder="Ex.: 000.000.000-00"></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" class="py-0">
                      <v-select variant="outlined" ref="installments" label="Parcelas" v-if="card_config.qtd_max_installments >= 1 && installments.length > 0" v-model="installment" :items="installments" item-title="value" item-value="id">
                        <template v-slot:item="data">
                          <v-list-item @click="escolheParcelas(data.item.raw.id, data.item.raw.value)">
                            <v-list-item-title class="link-menu ms-3 text-uppercase">{{ data.item.raw.value }}</v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col> -->
                  </v-row>
                </v-form>
              </v-col>
              <v-col cols="12" v-if="is_online_payment == 2">
                <v-row>
                  <v-col cols="12" class="text-center">
                    <b>A Chave Pix Copia e Cola e o QRCode para o pagamento serão disponibilizados após a finalização do pedido.</b>
                  </v-col>
                  <v-col cols="12" class="mt-2 text-center">
                    <span>
                      Para o caso de variações do valor total do pedido causados por rupturas ou produtos pesáveis, por favor informe sua chave Pix para que possamos fazer o reembolso da diferença:
                    </span>
                  </v-col>
                  <v-col cols="12" class="d-flex mt-2 justify-center">
                    <v-text-field variant="outlined" label="Digite aqui a sua chave Pix" v-model="chave_pix"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="is_online_payment == 0">
                <span class="text-color-0 text-large font-weight-bold">2. Selecione uma das opções de pagamento</span>
                <v-radio-group v-model="payment_method" :hide-details="true" class="text-color-0 mt-4" v-if="payment_method != 1">
                  <v-radio class="border rounded py-1 mt-2" :value="pgto.id" v-for="pgto in getPayments()" :key="pgto.id" :class="payment_method == pgto.id ? 'text-color-1 border-color-1':''">
                    <template v-slot:label>
                      <div class="d-flex align-center">
                        <img v-if="pgto.image != '' && pgto.image != null && pgto.image != undefined && pgto.image != 'no-image' && !pgto.name.includes('Cartão Supermercado')" class="pgto-ico" :src="pgto.image">
                        <img v-else src="@/assets/images/logo-supermercado.png" class="pgto-ico" :alt="pgto.name">
                        <span class="ms-3">{{ pgto.name.replace("Cartão Supermercado",  group) }}</span>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <div v-if="payment_method == 1">
                  <div class="d-flex align-center border rounded text-color-0 mt-4 pa-2">
                    <div class="text-color-2 cursor-pointer d-flex align-center" @click="payment_method = null"><v-icon icon="mdi-chevron-left"></v-icon> <span class="mb-1">voltar</span></div>
                    <img class="pgto-ico ms-6" :src="'https://api.vrconnect.com.br/bins/v1.00/8?f=1'">
                    <span class="ms-3">Dinheiro</span>
                  </div>
                  <v-checkbox density="compact" label="Necessita de troco?" v-model="necessitaTroco" inline hide-details class="border rounded text-color-0 mt-4 px-2"></v-checkbox>
                  <v-text-field v-if="necessitaTroco == true" variant="outlined" label="Quanto?" v-model.lazy="change_value" v-money="money" class="mt-4"></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="step.value == 4" class="text-color-0">
              <v-col class="v-col-12 py-2">
                <v-card variant="outlined" flat class="border">
                  <div class="pa-2 d-flex justify-space-between align-center">
                    <span class="text-color-1 font-weight-bold pa-2">Endereço de {{ getSelectedAddress.destiny_type ? 'Entrega': 'Retirada' }}</span>
                    <v-btn variant="text" flat class="text-color-2 font-weight-bold" @click="jumpStep(1)">Alterar</v-btn>
                  </div>
                  <div class="px-4 pb-4 text-color-0">
                    <div v-if="getSelectedAddress.address_nickname != '' && getSelectedAddress.address_nickname != null"><b>{{ getSelectedAddress.address_nickname }}</b><br></div>
                    {{ getSelectedAddress.street }}, {{ getSelectedAddress.num }}<br>
                    {{ getSelectedAddress.district }} - {{ getSelectedAddress.city }} - {{ getSelectedAddress.state }}<br>
                    <b>CEP:</b> {{ getSelectedAddress.zip_code }}<br>
                    <b v-if="getSelectedAddress.complement != ''">Complemento:</b> {{ getSelectedAddress.complement }}
                  </div>
                </v-card>
              </v-col>
              <v-col class="v-col-12 py-2">
                <v-card variant="outlined" flat class="border">
                  <div class="pa-2 d-flex justify-space-between align-center">
                    <span class="text-color-1 font-weight-bold pa-2">Data da {{ getSelectedAddress.destiny_type ? 'Entrega': 'Retirada' }}</span>
                    <v-btn variant="text" flat class="text-color-2 font-weight-bold" @click="jumpStep(1)">Alterar</v-btn>
                  </div>
                  <div class="px-4 pb-4 text-color-0">
                    <span v-if="opt_express == '0'">{{ $formatDate(dt_delivery + " 00:00:00") }}<br>
                    Das {{ hr_delivery.initial_hr_delivery }} às {{ hr_delivery.final_hr_delivery }}</span>
                    <span v-else>Entrega Express em no máximo {{ formatTime(getSelectedAddress.area.express.estimated_time) }}</span>
                    <br>
                    <span>Pessoa que irá receber: <b>{{ autorizado.res_name_withdrawal != "" ? autorizado.res_name_withdrawal : getUserInfo.name }}</b> </span> <span v-if="autorizado.res_doc_withdrawal != ''">({{ autorizado.res_doc_withdrawal }})</span>
                  </div>
                </v-card>
              </v-col>
              <v-col class="v-col-12 py-2">
                <v-card variant="outlined" flat class="border">
                  <div class="pa-2 d-flex justify-space-between align-center">
                    <span class="text-color-1 font-weight-bold pa-2">Forma de Pagamento</span>
                    <v-btn variant="text" flat class="text-color-2 font-weight-bold" @click="jumpStep(3)">Alterar</v-btn>
                  </div>
                  <div v-if="is_online_payment == 0" class="px-4 pb-4 text-color-0">
                    <b>Pagamento na {{ getSelectedAddress.destiny_type ? 'Entrega': 'Retirada' }}</b><br>
                    <span v-if="payment_method == 1">Dinheiro</span>
                    <span v-else>{{ getPaymentById(payment_method).name }}</span>
                    <br>
                    <span v-if="payment_method == 1 && change_value > 0">Necessita troco para <b>{{ $formatNumber(change_value, {style: 'currency', currency: 'BRL'}) }}</b></span>
                  </div>
                  <div v-if="is_online_payment == 1" class="px-4 pb-4">
                    Pagamento Online - Cartão<br>
                  </div>
                  <div v-if="is_online_payment == 2" class="px-4 pb-4">
                    Pagamento Online - Pix<br>
                  </div>
                </v-card>
              </v-col>
              <v-col class="v-col-12 py-2" v-if="obs_order != ''">
                <v-card variant="outlined" flat class="border">
                  <div class="pa-2 d-flex justify-space-between align-center">
                    <span class="text-color-1 font-weight-bold pa-2">Observação</span>
                    <v-btn variant="text" flat class="text-color-2 font-weight-bold" @click="jumpStep(2)">Alterar</v-btn>
                  </div>
                  <div class="px-4 pb-4 text-color-0">
                    <span>{{ obs_order }}</span>
                  </div>
                </v-card>
              </v-col>
              <v-col class="v-col-12 py-2">
                <v-card variant="outlined" flat class="border">
                  <div class="pa-2 d-flex justify-space-between align-center">
                    <span class="text-color-1 font-weight-bold pa-2">Caso falte algum produto da sua compra</span>
                    <v-btn variant="text" flat class="text-color-2 font-weight-bold" @click="jumpStep(2)">Alterar</v-btn>
                  </div>
                  <div class="px-4 pb-4 text-color-0">
                    <span v-if="opt_missing == 1">Substituir por produto similar e de preço semelhante</span>
                    <span v-if="opt_missing == 2">Excluir o item da minha compra</span>
                    <span v-if="opt_missing == 3">Desejo receber contato pelo número: <b>{{ opt_missing_obs }}</b></span>
                  </div>
                </v-card>
              </v-col>
              <v-col class="v-col-12 py-2">
                <v-card variant="outlined" flat class="border">
                  <div class="pa-2 d-flex justify-space-between align-center">
                    <span class="text-color-1 font-weight-bold pa-2">Produtos</span>
                    <v-btn variant="text" flat class="text-color-2 font-weight-bold" @click="jumpStep(2)">Alterar</v-btn>
                  </div>
                  <v-list class="w-100 pa-0 ma-0 br-0" v-for="m in getItensCart" :key="m.catid">
                    <v-list-item density="compact" class="bg-color-gray text-color-0 text-start py-0 text-small">{{ getCategoryById(m.catid).name }} ({{ m.qtd }} {{ m.qtd > 1 ? ' itens':' item' }}) - {{ $formatNumber(m.total, {style: 'currency', currency: 'BRL'}) }}</v-list-item>
                    <ProductList v-for="p in m.itens" :key="p.sku" :product="p" :block="true"></ProductList>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <hr class="fine-line">
          </v-col>
          <v-col v-if="step.value >= 2" class="v-col-12 v-col-lg-4 offset-lg-2">
            <v-btn variant="flat" block size="x-large" class="bg-color-gray text-color-0" @click="previousStep(step.value)">Voltar</v-btn>
          </v-col>
          <v-col v-if="step.value < 4" :class="step.value > 1 ? 'v-col-12 v-col-lg-4' : 'v-col-12 v-col-lg-8 offset-lg-2'">
            <v-btn variant="flat" block size="x-large" class="bg-color-1 text-color-white" @click="nextStep(step.value)">Continuar</v-btn>
          </v-col>
          <v-col v-if="step.value == 4" class="v-col-12 v-col-lg-4">
            <v-btn variant="flat" block size="x-large" class="bg-color-2 text-color-white" @click="confirmConcluir()">Confirmar</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="v-col-12 v-col-lg-4" :order="mobile == false ? 2 : 1">
        <v-row class="bg-white px-3 pa-lg-2 mt-lg-0">
          <v-col class="v-col-6 d-flex align-center">
            <b class="text-color-0">Resumo do seu pedido</b>
          </v-col>
          <v-col class="v-col-6">
            <v-checkbox density="compact" v-model="is_nf" :disabled="step.value == 4" inline hide-details class="text-color-0 justify-end">
              <template v-slot:label>
                <b class="text-color-0">CPF na nota?</b>
              </template>
            </v-checkbox>
          </v-col>
          <v-col class="v-col-12 pt-1">
            <v-alert variant="tonal" class="alert-custom-1">
              <template v-slot:prepend>
                <v-icon icon="mdi-alert-outline" class="text-color-1" size="x-large"></v-icon>
              </template>
              <span class="text-small text-color-1">Produtos de peso podem sofrer variação de preço para mais ou para menos.</span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row class="bg-white px-3 pa-lg-2 mt-7" v-if="checkModules(8) == 8 && ((step.value < 4 && mobile == false) || (step.value == 3 && mobile == true))">
          <CarteiraDigital></CarteiraDigital>
        </v-row>
        <v-row class="bg-white px-3 pa-lg-2 mt-7" v-if="checkModules(11) == 11 && ((step.value < 4 && mobile == false) || (step.value == 3 && mobile == true))">
          <Cupons></Cupons>
        </v-row>
        <v-row class="bg-white px-3 pa-lg-2 mt-7" v-if="order != null">
          <v-col class="v-col-6">
            <span class="text-color-0">Valor da Compra</span>
          </v-col>
          <v-col class="v-col-6 text-end">
            <span class="text-color-1">{{ $formatNumber(getTotalValueCart, {style: 'currency', currency: 'BRL'}) }}</span>
          </v-col>
          <v-col cols="12" class="pa-0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6">
            <span class="text-color-0">Frete</span>
          </v-col>
          <v-col class="v-col-6 text-end">
            <span class="text-color-1" v-if="order.shipping_fee > 0">+ {{ $formatNumber(order.shipping_fee, {style: 'currency', currency: 'BRL'}) }}</span>
            <span class="text-color-green" v-else>Grátis</span>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="order.total_descontos > 0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6" v-if="order.total_descontos > 0">
            <span class="text-color-0">Descontos</span>
          </v-col>
          <v-col class="v-col-6 text-end" v-if="order.total_descontos > 0">
            <span class="text-color-green">- {{ $formatNumber(order.total_descontos, {style: 'currency', currency: 'BRL'}) }}</span>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="order.wallet_value > 0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6" v-if="order.wallet_value > 0">
            <span class="text-color-0">Carteira Digital</span>
          </v-col>
          <v-col class="v-col-6 text-end" v-if="order.wallet_value > 0">
            <span class="text-color-green">- {{ $formatNumber(order.wallet_value, {style: 'currency', currency: 'BRL'}) }}</span>
          </v-col>
          <v-col cols="12" class="pa-0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6">
            <b class="text-color-0 text-xlarge">Valor Total</b>
          </v-col>
          <v-col class="v-col-6 text-end">
            <b class="text-color-1 text-xlarge">{{ $formatNumber(order.total_final, {style: 'currency', currency: 'BRL'}) }}</b>
          </v-col>
        </v-row>
        <v-row class="bg-white px-3 pa-lg-2 mt-7" v-else>
          <v-skeleton-loader type="text, divider, text, divider, text" width="100%"></v-skeleton-loader>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <DialogAddress :fechar="fechar" :model="modelAddress" :startIsEntrega="startIsEntrega"></DialogAddress>
  <DialogPayments :fechar="fechar" :model="modelPayments" :apo_validas="getPaymentOnline"></DialogPayments>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Svgs from '@/components/Svgs.vue';
import ProductList from '@/components/ProductList.vue';
import DialogAddress from '@/components/DialogAddress.vue';
import CreditCard from '@/components/CreditCard.vue';
import DialogPayments from '@/components/DialogPayments.vue';
import CarteiraDigital from '@/components/CarteiraDigital.vue';
import Cupons from '@/components/Cupons.vue';
import { month, weekday, flags } from '@/store/services/utils.js';
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel';
import { VMoney } from 'v-money';
export default {
  name: 'Checkout',
  directives: { money: VMoney },
  components: {
    Svgs,
    ProductList,
    DialogAddress,
    Carousel,
    Slide,
    CreditCard,
    CarteiraDigital,
    Cupons,
    DialogPayments
  },
  data(){
    return {
      group: import.meta.env.VITE_PAGE_TITLE,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      modelAddress: false,
      modelPayments: false,
      inatividade: null,
      startIsEntrega: null,
      is_nf: false,
      step: {
        value: 1,
        one: 'active',
        two: '',
        three: '',
        four: ''
      },
      autorizacao: false,
      autorizado: {
        res_name_withdrawal: "",
        res_doc_withdrawal: ""
      },
      opt_missing: null,
      opt_missing_obs: "",
      obs_order: "",
      is_online_payment: null,
      payment_method: null,
      necessitaTroco: false,
      change_value: 0,
      order: null,
      card: {
        number: "",
        name: "",
        doc: "",
        valid: "",
        cvv: "",
        installment: 1
      },
      installment: 1,
      installments: [],
      card_config: {
        id: null,
        name: "",
        min_lenght: 16,
        flag_id: null,
        front: true,
        minimum_installment_amount: 1,
        fees: 0,
        qtd_max_installments: 1,
        qtd_max_interest_free_installments: 1,
        primary_color: "#ebebeb",
        secondary_color: "#929292",
        icon: 'no-image',
        image: 'no-image',
        maskNumber: {
          mask: "#### #### #### ####"
        },
        maskCvv: {
          mask: "###"
        },
        maskValid: {
          mask: "##/##"
        },
        maskCpfCnpj: {
          mask: "###.###.###-##"
        },
      },
      dt_delivery: null,
      hr_delivery: null,
      horarios: [],
      dateformat: "dd/MM/yyyy",
      loading: false,
      loadingTimes: true,
      allowedDates: [],
      allowedTimes: [],
      opt_express: "0",
      express: {
        limit: 0,
        time: 0
      },
      masks: {
        cpf: {
          mask: "###.###.###-##",
        },
        phone: {
          mask: "(##) #####-####",
        },
      },
      mobile: false,
      disabledvalidation: false,
      rules: {
        required: v => !!v || 'Este campo é obrigatório.',
        minNumber: v => (v && v.replaceAll(" ", "").length >= this.card_config.min_lenght) || 'Este campo deve conter no mínimo ' + this.card_config.min_lenght + ' caracteres.',
        minCvv: v => (v && v.length >= 3) || 'Este campo deve conter no mínimo 3 caracteres.',
        minValid: v => (v && v.length >= 4) || 'Este campo deve conter no mínimo 5 caracteres.',
        minCpf: v => (v && v.length >= 14) || 'Este campo deve conter no mínimo 14 caracteres.',
        minName: v => (v && v.length >= 5) || 'Este campo deve conter no mínimo 5 caracteres.',
        isFlagAccept: v => {
          var tamanho = v != null ? v.length: 0;
          if((this.card_config.id == null && tamanho > 6 )){
            return 'O estabelecimento não aceita essa bandeira para pagamento online.';
          } else {
            return true;
          }
        },
        isDateValid: v => {
          if(v != null){
            var val = v.split("/");
            var mes = new Date().getMonth()+1;
            var ano = new Date().getFullYear();
            ano = parseInt(ano.toString().substring(2));
            val[0] = parseInt(val[0]);
            val[1] = parseInt(val[1]);
            if(v.length == 5 && ano > val[1]){
              return 'Data ultrapassada.';
            } else if(v.length == 5 && (ano == val[1] && mes > val[0])){
              return 'Data ultrapassada.';
            } else {
              return true;
            }
          } else {
            return true;
          }
        },
        isMonthValid: v => {
          if(v != null){
            var val = v.split("/");
            val[0] = parseInt(val[0]);
            if(v.length > 1 && (val[0] == 0 || val[0] > 12)){
              return 'Mês inválido.';
            } else {
              return true;
            }
          } else {
            return true;
          }
        },
      },
    }
  },
  computed: {
    ...mapGetters('cart', {
      getItens: 'getItens',
      getItensCart: 'getItensCart',
      getTotalCart: 'getTotalCart',
      getTotalValueCart: 'getTotalValueCart',
      getQtdeTotal: 'getQtdeTotal'
    }),
    ...mapGetters('main', {
      checkModules: 'checkModules',
      getCategoryById: 'getCategoryById',
      getCategories: 'getCategories',
      getPayments: 'getPayments',
      getPaymentById: 'getPaymentById',
      getPaymentOnlineById: 'getPaymentOnlineById',
      getConfig: 'getConfig',
      getPaymentOnline: 'getPaymentOnline'
    }),
    ...mapGetters('user', {
      getSelectedAddress: 'getSelectedAddress',
      getUserInfo: 'getUserInfo',
      getChavePix: 'getChavePix'
    }),
    ...mapGetters('carteira', {
      getSaldoCarteira: 'getSaldoCarteira'
    }),
    ...mapGetters('order', {
      getOrderRequest: 'getOrderRequest'
    }),
    ...mapGetters('cupons', {
      getCupons: 'getCupons'
    }),
    ...mapState('user', {
      loadingUser: 'loadingUser'
    }),
    ...mapState('cart', {
      modifiedShoppingCart: 'modifiedShoppingCart'
    }),
    getValorMinimo(){
      if(this.getSelectedAddress.destiny_type == 0){
        return this.getConfig.storeConfig.min_withdrawal_value_order;
      } else {
        if(this.opt_express == '1'){
          return this.getConfig.storeConfig.min_express_value_order;
        } else {
          return this.getConfig.storeConfig.min_delivery_value_order;
        } 
      }
    },
    itensAnalytics: function(){
      var itens = [];
      this.getItens.forEach(element => {
        if(element.offer != null){ // Quando é oferta
        var nameExclusive = element.offer.cluster_id > 0 ? "Oferta Exclusiva": "Oferta";
        var offerExclusive = element.offer.cluster_id > 0 ? "oe": "o";
        var nameOffer = element.offer.is_offer_club == 0 ? " (Ative e Pague)": " (Preço Clube)";
        var codeOffer = element.offer.is_offer_club == 0 ? "ap": "pc";
          if(element.offer.dh_activated != null && element.offer.offer_connect > 0){ // Quando tem preço clube ou ative e pague ativado
            if(element.offer.amount_connect >= element.cart.amount || element.offer.is_offer_unlimited == 1){ // Quando a qtd disponível é igual ou maior que a qtd do item
              itens.push({
                "currency" : "BRL",
                "item_id": element.sku,
                "item_name": element.name,
                "item_category": this.getCategoryById(element.catid) ? this.getCategoryById(element.catid).name: "",
                "price": element.offer.offer_connect,
                "quantity": element.cart.amount,
                "promotion_id": offerExclusive + codeOffer + "-" + element.sku,
                "promotion_name": nameExclusive + nameOffer,
              });
            } else { // Quando a qtd disponível é menor que a qtd do item
              itens.push({
                "currency" : "BRL",
                "item_id": element.sku,
                "item_name": element.name,
                "item_category": this.getCategoryById(element.catid) ? this.getCategoryById(element.catid).name: "",
                "price": element.offer.offer_connect,
                "quantity": element.offer.amount_connect,
                "promotion_id": offerExclusive + codeOffer + "-" + element.sku,
                "promotion_name": nameExclusive + nameOffer,
              });
              itens.push({
                "currency" : "BRL",
                "item_id": element.sku,
                "item_name": element.name,
                "item_category": this.getCategoryById(element.catid) ? this.getCategoryById(element.catid).name: "",
                "price": element.offer.offer_price,
                "quantity": element.cart.amount - element.offer.amount_connect,
                "promotion_id": offerExclusive+ "-" + element.sku,
                "promotion_name": nameExclusive,
              });
            }
          } else { // Quando não tem preço clube ou ative e pague ativado
            itens.push({
              "currency" : "BRL",
              "item_id": element.sku,
              "item_name": element.name,
              "item_category": this.getCategoryById(element.catid) ? this.getCategoryById(element.catid).name: "",
              "price": element.offer.offer_price,
              "quantity": element.cart.amount,
              "promotion_id": offerExclusive + "-" + element.sku,
              "promotion_name": nameExclusive,
            });
          }
        } else { // Quando não é oferta
          itens.push({
            "currency" : "BRL",
            "item_id": element.sku,
            "item_name": element.name,
            "item_category": this.getCategoryById(element.catid) ? this.getCategoryById(element.catid).name: "",
            "price": element.price,
            "quantity": element.cart.amount,
            "promotion_id": "p-" + element.sku,
            "promotion_name": "Produto",
          });
        }
    });
    return itens;
    }
  },
  watch: {
    getQtdeTotal: function (i){
      if(this.opt_express == "1" && this.step.value > 0 && this.getSelectedAddress != null && this.getSelectedAddress.area != null && this.getSelectedAddress.area.express != null && this.getSelectedAddress.area.express.is_able == 1){
        if(i > this.getConfig.storeConfig.max_qtd_items_express){
          this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você ultrapassou a quantidade limite de itens para a modalidade de entrega Express, por favor selecione um horário de agendamento.", fechar: this.voltarExpress });
        }
      }
      this.checkCuponsMin();
    },
    opt_express: function (opt){
      this.dt_delivery = null;
      this.hr_delivery = null;
      this.updateFrete({ "address": this.getSelectedAddress, "express": this.opt_express });
      if(this.getSelectedAddress.destiny_type != 0){
        this.getSelectedAddress.destiny_type = opt == "1" ? 2 : 1;
      }
    },
    'payment_method': function (){
      this.necessitaTroco = false;
    },
    necessitaTroco: function (){
      this.change_value = 0;
    },
    'getSelectedAddress': function (address, old){
      this.dt_delivery = null;
      if(old.destiny_type != address.destiny_type && (old.address_id != null || old.store_id != null)){
        this.loadTimes(address);
      } else if(old.destiny_type >= 1 && (old.address_id != address.address_id)){
        this.loadTimes(address);
      }
    },
    'getSelectedAddress.destiny_type': function(){
        this.loadTimes(this.getSelectedAddress);
    },
    dt_delivery: function(data){
      this.hr_delivery = null;
      if(data != null){
        this.allowedTimes = this.horarios.filter(element => element.date == data);
      } else {
        this.allowedTimes = [];
      }
    },
    'getCupons.length':function(){
      this.updateFrete({ "address": this.getSelectedAddress, "express": this.opt_express });
      var total_descontos = 0;
      if(this.getCupons.length > 0){
        this.getCupons.forEach(cupom => {
          if(cupom.type_coupon == 1){
            total_descontos += cupom.value_coupon;
          }
          if(cupom.type_coupon == 0){
            total_descontos += ((cupom.value_coupon/100) * this.getTotalValueCart);
          }
        });
      }
      this.updateDesconto(total_descontos);
    },
    'card.doc': function (val){
      if(val.length > 14){
        this.card_config.maskCpfCnpj.mask = '##.###.###/####-##';
      } else {
        this.card_config.maskCpfCnpj.mask = '###.###.###-##';
      }
    },
    'card.number': function (val) {
      if (val.length >= 2) {
        var cardnumber = val.replace(/[^0-9]+/g, '');
        let check = true;
        this.getPaymentOnline.forEach(flag => {
          let rule = new RegExp(flag.rule);
          if(rule.test(cardnumber)) {
            check = false;
            this.card_config.id = parseInt(flag.authorized_flag);
            this.card_config.name = flag.name;
            this.card_config.maskNumber.mask = flag.number_mask;
            this.card_config.maskCvv.mask = flag.code_mask;
            this.card_config.min_lenght = flag.minimum_characters;
            this.card_config.flag_id = flag.id;
            this.card_config.minimum_installment_amount = flag.minimum_installment_amount;
            this.card_config.fees = flag.fees;
            this.card_config.qtd_max_installments = flag.qtd_max_installments;
            this.card_config.qtd_max_interest_free_installments = flag.qtd_max_interest_free_installments;
            this.card_config.primary_color = flag.primary_color;
            this.card_config.secondary_color = flag.secondary_color;
            this.card_config.image = flag.image;
            this.card_config.icon = flag.icon;
            this.card_config.id_payment_method = flag.id_payment_method;
          }
        });
        if(check){
          this.card_config.id = null;
          this.card_config.name = "";
          this.card_config.maskNumber.mask = '#### #### #### ####';
          this.card_config.maskCvv.mask = '###';
          this.card_config.min_lenght = 16;
          this.card_config.flag_id = 'indefinido';
          this.card_config.icon = 'no-image';
          this.card_config.image = 'no-image';
          this.card_config.minimum_installment_amount = 1;
          this.card_config.fees = 0;
          this.card_config.qtd_max_installments = 1;
          this.card_config.qtd_max_interest_free_installments = 1;
          this.card_config.primary_color = "#ebebeb";
          this.card_config.secondary_color = "#929292";
          this.card_config.id_payment_method = null;
        }
      } else {
        this.card_config.id = null;
        this.card_config.name = "";
        this.card_config.maskNumber.mask = '#### #### #### ####';
        this.card_config.maskCvv.mask = '###';
        this.card_config.min_lenght = 16;
        this.card_config.flag_id = 'indefinido';
        this.card_config.icon = 'no-image';
        this.card_config.image = 'no-image';
        this.card_config.minimum_installment_amount = 1;
        this.card_config.fees = 0;
        this.card_config.qtd_max_installments = 1;
        this.card_config.qtd_max_interest_free_installments = 1;
        this.card_config.primary_color = "#ebebeb";
        this.card_config.secondary_color = "#929292";
        this.card_config.id_payment_method = null;
      }
    },
    'card_config.id': function (i){
      if(i == null){
        this.installments = [];
      } else {
        this.installments = [];
        let parcelas = Math.floor(this.order.total_final / this.card_config.minimum_installment_amount);
        parcelas = parcelas > this.card_config.qtd_max_installments ? this.card_config.qtd_max_installments : parcelas;
        parcelas = parcelas == 0 ? 1 : parcelas;
        for(let i = 1;i <= parcelas; i++){
          let value = parseFloat(this.card_config.qtd_max_interest_free_installments >= i ? this.order.total_final / i : (this.order.total_final + (this.card_config.fees/100 * this.order.total_final)) / i).toFixed(2).replace(".", ",");
          this.installments.push({
            id: i,
            value: "EM "+ i + "X DE R$ " + value + (this.card_config.qtd_max_interest_free_installments < i && this.card_config.fees > 0 ? " COM JUROS": " SEM JUROS"),
          });
        }
      }
    },
    modifiedShoppingCart(v){
      if(v == 1){
        this.clearModifiedShoppingCart();
        this.$store.dispatch('cart/loadItensCart').then(() => {
          this.step = {
            one: 'completed',
            two: 'active',
            three: '',
            four: '',
            value: 2
          };
          this.emitter.emit('dialogMessage', { 
            title: "Atenção!",
            message: "Houve algumas alterações nos produtos e seu carrinho foi atualizado com sucesso. Clique abaixo para revisar os itens novamente."
          });
        });
      }
    }
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
      storeTimes: 'storeTimes',
      loadPayments: 'loadPayments',
      loadOnlinePayments: 'loadOnlinePayments'
    }),
    ...mapActions('order', {
      preOrder: 'preOrder',
      finalizeOrder: 'finalizeOrder',
      updateFrete: 'updateFrete',
      updateDesconto: 'updateDesconto',
      getWalletValue: 'getWalletValue',
      updateTotalFinal: 'updateTotalFinal'
    }),
    ...mapActions('cart', {
      clearCart: 'clearCart',
      activeClub: 'activeClub',
      clearModifiedShoppingCart: 'clearModifiedShoppingCart'
    }),
    ...mapActions('user', {
      deliveryTimes: 'deliveryTimes'
    }),
    ...mapActions('carteira', {
      loadCarteira: 'loadCarteira'
    }),
    ...mapActions('cupons', {
      loadCupons: 'loadCupons',
      checkCupons: 'checkCupons',
      delCupom: 'delCupom'
    }),
    month,
    weekday,
    escolheParcelas(x, y){
      this.installment = y;
      this.card.installment = x;
      this.$refs.installments.blur();
    },
    newAddress(){
      this.emitter.emit('dialogAddress', { address: null });
    },
    toDate(d){
      let data = new Date(d);
      return data;
    },
    formatDate(d){
      let data = d.getFullYear()+"-"+(d.getMonth() + 1).toString().padStart(2, '0')+"-"+d.getDate().toString().padStart(2, '0')+" 00:00:00";
      return data;
    },
    formatTime(t){
      if(t < 60){
        return t+ " minutos";
      } else {
        let h = Math.floor(t/60);
        let m = Math.round(((t/60)-h)*60);
        return h+"h"+m;
      }
    },
    loadTimes(address){
      if(this.loading == false) {
        this.updateFrete({ "address": this.getSelectedAddress, "express": this.opt_express });
        this.loading = true;
        this.startIsEntrega = address.destiny_type;
        this.horarios = [];
        this.allowedDates = [];
        this.allowedTimes = [];
        if(address != null && address.street != undefined){
          this.opt_express = address.destiny_type == 2 ? '1' : '0';
          if(address.destiny_type >= 1){
            this.loadingTimes = true;
            this.deliveryTimes({ id: address.address_id, express: (address.destiny_type == 2 ? '1' : '0') }).then(function(response){
              if(response){
                let lastdate = "";
                response.forEach(element => {
                  let date = element.date + " 00:00:00";
                  if(lastdate != ""){
                    lastdate = this.toDate(lastdate);
                    let day = lastdate.getDate() + 1;
                    lastdate = this.toDate(lastdate.setDate(day));

                    while(this.formatDate(lastdate) != date){
                      this.allowedDates.push(
                        {
                          data: this.formatDate(lastdate),
                          disabled: true
                        }
                      );
                      day = lastdate.getDate() + 1;
                      lastdate = this.toDate(lastdate.setDate(day));
                    }
                  }

                  this.allowedDates.push(
                    {
                      data: date,
                      disabled: false
                    }
                  );
                  lastdate = date;

                  element.times.forEach(subelement => {
                    let hora = {
                      date: subelement.date,
                      title: "Das " + subelement.start.split(":")[0]+"h"+subelement.start.split(":")[1] + " às " + subelement.end.split(":")[0]+"h"+subelement.end.split(":")[1],
                      value: {
                        initial_hr_delivery: subelement.start,
                        final_hr_delivery: subelement.end
                      }
                    };
                    this.horarios.push(hora);
                  });
                });
              }
              this.loadingTimes = false;
              this.loading = false;
            }.bind(this));
          } else {
            this.loadingTimes = true;
            this.storeTimes(address.store_id).then(function(response){
              if(response){
                let lastdate = "";
                response.forEach(element => {
                  let date = element.date + " 00:00:00";
                  if(lastdate != ""){
                    lastdate = this.toDate(lastdate);
                    let day = lastdate.getDate() + 1;
                    lastdate = this.toDate(lastdate.setDate(day));

                    while(this.formatDate(lastdate) != date){
                      this.allowedDates.push(
                        {
                          data: this.formatDate(lastdate),
                          disabled: true
                        }
                      );
                      day = lastdate.getDate() + 1;
                      lastdate = this.toDate(lastdate.setDate(day));
                    }
                  }

                  this.allowedDates.push(
                    {
                      data: date,
                      disabled: false
                    }
                  );
                  lastdate = date;

                  element.times.forEach(subelement => {
                    let hora = {
                      date: subelement.date,
                      title: "Das " + subelement.start.split(":")[0]+"h"+subelement.start.split(":")[1] + " às " + subelement.end.split(":")[0]+"h"+subelement.end.split(":")[1],
                      value: {
                        initial_hr_delivery: subelement.start,
                        final_hr_delivery: subelement.end
                      }
                    };
                    this.horarios.push(hora);
                  });
                });
              }
              this.loadingTimes = false;
              this.loading = false;
            }.bind(this));
          }
        } else {
          this.loading = false;
        }
      }
    },
    fechar: function(){
      this.modelAddress = false;
      this.modelPayments = false;
    },
    voltarExpress: function(){
      this.opt_express = "0";
      this.jumpStep(1);
    },
    jumpStep(n){
      this.startInatividade();
      switch(n){
        case 1: 
          if(this.step.one == 'completed'){
            this.step.one = "active";
            this.step.two = "";
            this.step.three = "";
            this.step.four = "";
            this.step.value = n;
          }
        break;
        case 2: 
          if(this.step.two == 'completed'){
            this.step.one = "completed";
            this.step.two = "active";
            this.step.three = "";
            this.step.four = "";
            this.step.value = n;
          }
        break;
        case 3: 
          if(this.step.three == 'completed'){
            this.step.one = "completed";
            this.step.two = "completed";
            this.step.three = "active";
            this.step.four = "";
            this.step.value = n;
          }
        break;
      }
    },
    async nextStep(n){
      this.startInatividade();
      switch(n){
        case 1:
          if ((this.dt_delivery != null && this.hr_delivery != null) || this.opt_express == "1"){
            if(this.opt_express == "1" && this.getQtdeTotal > this.getConfig.storeConfig.max_qtd_items_express){
              this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você ultrapassou a quantidade limite de itens para a modalidade de entrega Express, por favor selecione um horário de agendamento." });
            } else {
              if(this.getTotalValueCart < this.getValorMinimo){
                let tipo = this.getSelectedAddress.destiny_type == 0 ? 'retirada': (this.getSelectedAddress.destiny_type == 1 ? 'entrega agendada': 'entrega express');
                this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Não é possível selecionar esta opção. O valor mínimo do pedido para " + tipo + " é de R$ " + this.getValorMinimo });
              } else if(this.autorizacao == false || (this.autorizacao == true && this.autorizado.res_doc_withdrawal != "" && this.autorizado.res_name_withdrawal != "" )){
                if(this.is_nf == false){
                  this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Deseja inserir CPF na nota fiscal?", response: this.addCPF});
                }
                window.scroll({ top: 0,  left: 0 });
                this.step.one = "completed";
                this.step.two = "active";
                this.step.value = n + 1;
              } else {
                this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Por favor, informe os dados da pessoa autorizada a " + (this.getSelectedAddress.destiny_type ? 'receber': 'retirar') });
              }
            }
          } else if(this.getSelectedAddress.destiny_type >= 1 && this.getSelectedAddress.area == null) {
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: this.getConfig.storeConfig.min_withdrawal_value_order >= 0 ? 'Infelizmente não efetuamos entrega para este endereço. Por favor, verifique se o endereço está correto ou retire suas compras em nossa unidade.' : 'Infelizmente não efetuamos entrega para este endereço. Por favor, verifique se o endereço está correto.' });
          } else if(this.getSelectedAddress.destiny_type == 0 && this.getConfig != null && this.getConfig.storeConfig != null && this.getConfig.storeConfig.min_withdrawal_value_order < 0) {
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: 'Infelizmente não efetuamos retirada nesta unidade. Por favor, altere para um endereço de entrega.' });
          } else {
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Por favor, selecione o dia e horário de " + (this.getSelectedAddress.destiny_type ? 'Entrega': 'Retirada') });
          }
        break;
        case 2:
          if(this.opt_missing == null || (this.opt_missing == 3 && this.opt_missing_obs == "")){
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Por favor, escolha o que fazer caso falte algum produto da sua compra." });
          } else if(this.getTotalValueCart < this.getValorMinimo){
            let tipo = this.getSelectedAddress.destiny_type == 0 ? 'retirada': (this.getSelectedAddress.destiny_type == 1 ? 'entrega agendada': 'entrega express');
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Não é possível selecionar esta opção. O valor mínimo do pedido para " + tipo + " é de R$ " + this.getValorMinimo });
          } else {
            this.loadPayments({ destiny_type: this.getSelectedAddress.destiny_type >= 1 ? 1 : 0, store: this.getSelectedAddress.store_id }).then(function(){
              window.scroll({ top: 0,  left: 0 });
              this.step.two = "completed";
              this.step.three = "active";
              this.step.value = n + 1;
            }.bind(this));
            this.loadOnlinePayments();
          }
        break;
        case 3:
          if(this.is_online_payment == 0 && this.payment_method != null){
            await this.preOrder();
            if (this.modifiedShoppingCart == 1) return;
            this.step.three = "completed";
            this.step.four = "active";
            this.step.value = n + 1;
            window.scroll({ top: 0,  left: 0 });
          } else if(this.is_online_payment == 1) {
            const { valid } = await this.$refs.payment.validate();
            if(valid){
              await this.preOrder();
              if (this.modifiedShoppingCart == 1) return;
              this.step.three = "completed";
              this.step.four = "active";
              this.step.value = n + 1;
              window.scroll({ top: 0,  left: 0 });
            }
          } else if(this.is_online_payment == 2) {
            if(this.chave_pix != "" && this.chave_pix != null){
              await this.preOrder();
              if (this.modifiedShoppingCart == 1) return;
              this.step.three = "completed";
              this.step.four = "active";
              this.step.value = n + 1;
              window.scroll({ top: 0,  left: 0 });
            } else {
              this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Por favor, informe sua chave Pix." });
            }
          } else {
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Por favor, selecione uma forma de pagamento." });
          }
        break;
      }
    },
    previousStep(n){
      this.startInatividade();
      this.step.value = n - 1;
      switch(n){
        case 2: 
          this.step.one = "active";
          this.step.two = "";
        break;
        case 3: 
          this.step.two = "active";
          this.step.three = "";
        break;
        case 4: 
          this.step.three = "active";
          this.step.four = "";
        break;
      }
      window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    },
    addCPF: function(r){
      this.is_nf = r;
    },
    startInatividade(){
      clearInterval(this.inatividade);
      this.inatividade = setInterval(() => {
        this.$router.push("/");
        clearInterval(this.inatividade);
      }, 1200000);
    },
    confirmConcluir(){
      let total = parseFloat(this.order.total_final).toFixed(2).replace(".", ",");
      this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você tem certeza de que deseja concluir está compra no valor total de R$ " + total, response: this.concluir});
    },
    concluir: function(r){
      if(r){
        let payment_method = null;
        let online_payment = null;
        let payment_type = "";
        switch (this.is_online_payment) {
          case "1":
            payment_method = this.card_config.id_payment_method;
            online_payment = this.paymentOnline();
            payment_type = this.getPaymentOnlineById(this.card_config.flag_id).name;
          break;
          case "2":
            payment_method = 28;
            online_payment = { chave_pix: this.chave_pix };
            payment_type = "Pix";
          break;
          default:
            payment_method = this.payment_method;
            online_payment = null;
            payment_type = this.getPaymentById(this.payment_method).name;
          break;
        }

        let parametros = {
          is_nf: this.is_nf ? 1 : 0,
          online_payment: online_payment,
          payment_method: payment_method,
          change_value: this.change_value != '' && this.change_value != undefined ? parseFloat(this.change_value.replace("R$ ", "").replace(".", "").replace(",", ".")): 0,
          res_name_withdrawal: this.autorizado.res_name_withdrawal,
          res_doc_withdrawal: this.autorizado.res_doc_withdrawal,
          opt_missing: parseInt(this.opt_missing),
          opt_missing_obs: this.opt_missing_obs,
          obs_order: this.obs_order,
          shipping_fee: this.order.shipping_fee,
          opt_express: parseInt(this.opt_express)
        }
        let sessionid = document.getElementById('sessionid').value;
        if(sessionid != ""){
          parametros.sessionid = sessionid;
        }
        if(this.opt_express == "0"){
          parametros.dt_delivery = this.dt_delivery,
          parametros.initial_hr_delivery = this.hr_delivery.initial_hr_delivery;
          parametros.final_hr_delivery = this.hr_delivery.final_hr_delivery;
        } else {
          var today = new Date();
          parametros.dt_delivery = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
          parametros.estimated_time = this.getSelectedAddress.area.express.estimated_time;
          parametros.area_id = this.getSelectedAddress.area.id;
        }
        this.finalizeOrder(parametros).then(function(response){
          if(response.cod == 200 || response.cod == 201){
            this.emitter.emit("sendAnalyticsEvent", { event: "add_shipping_info", parameters: { currency : "BRL", value: this.order.shipping_fee, items: this.itensAnalytics, shipping_tier: "Terrestre" } } );
            this.emitter.emit("sendAnalyticsEvent", { event: "add_payment_info", parameters: { currency : "BRL", value: this.getTotalValueCart, items: this.itensAnalytics, payment_type: payment_type } } );
            this.emitter.emit("sendAnalyticsEvent", { event: "purchase", parameters: { currency : "BRL", value: this.getTotalValueCart, items: this.itensAnalytics, transaction_id: response.return.order_id, shipping: this.order.shipping_fee } } );
            this.disabledvalidation = true;
            this.clearCart().then(function(){
              this.$router.push("/order");
            }.bind(this));
          } else {
            this.emitter.emit('dialogMessage', { title: "Ops!", message: response.msg});
            this.$store.dispatch('cart/loadItensCart').then(() => {
              this.jumpStep(2);
            });
          }
        }.bind(this));
      }
    },
    paymentOnline(){
      let data = this.maskData(this.card.number.replace(/ /g, ''))+','+this.maskData(this.card.valid.replace('/', ''))+','+this.maskData(this.card.cvv);
      let online_payment = {
        name: this.card.name,
        cpf: this.removemask(this.card.doc),
        authorization_id: this.card_config.id,
        installment: this.card.installment,
        data: btoa(data)
      }
      return online_payment;
    },
    removemask(value){
      return value.replaceAll(".", "").replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll("/", "");
    },
    maskData(data) {
      var retorno = '';
      if (data != '') {
        var dataSplited = data.split(/(?=\d+)/)
        var dataMask = [];
        switch (parseInt(dataSplited[(data.length - 1)])) {
          case 0:
            dataMask = [0, 2, 4, 1, 9, 7, 3, 8, 6, 5]
          break;
          case 1:
            dataMask = [3, 1, 9, 2, 5, 6, 4, 0, 8, 7]
          break;
          case 2:
            dataMask = [8, 3, 2, 0, 5, 4, 1, 9, 7, 6]
          break;
          case 3:
            dataMask = [4, 8, 0, 3, 7, 2, 5, 6, 1, 9]
          break;
          case 4:
            dataMask = [6, 0, 7, 9, 4, 5, 3, 1, 2, 8]
          break;
          case 5:
            dataMask = [9, 7, 6, 2, 1, 5, 8, 4, 0, 3]
          break;
          case 6:
            dataMask = [7, 0, 5, 2, 3, 8, 6, 9, 1, 4]
          break;
          case 7:
            dataMask = [1, 5, 9, 6, 4, 8, 3, 7, 0, 2]
          break;
          case 8:
            dataMask = [2, 5, 1, 7, 3, 4, 9, 6, 8, 0]
          break;
          case 9:
            dataMask = [1, 0, 2, 7, 3, 4, 6, 5, 8, 9]
          break;
        }
        dataSplited.forEach(function (element){
          retorno += dataMask[element];
        }.bind(this))
        return retorno;
      }
    },
    checkLayout(){
      var val = window.innerWidth;
      if (parseFloat(val) >= 1280) {
          this.mobile = false;
      } else {
          this.mobile = true;
      }
    },
    next() {
      this.$refs.carousel.slideTo(this.$refs.carousel.data.currentSlide._value + this.$refs.carousel.data.config.itemsToShow);
    },
    prev() {
      this.$refs.carousel.slideTo(this.$refs.carousel.data.currentSlide._value - this.$refs.carousel.data.config.itemsToShow);
    },
    checkCuponsMin(){
      if(this.disabledvalidation == false){
        let count = 0;
        let cupons = this.getCupons;
        cupons.forEach(element => {
          if(element.min_value_coupon > this.getTotalValueCart){
            this.delCupom(element);
            count++;
          }
        });
        if(count > 0){
          this.emitter.emit('dialogMessage', { title: "Ops!", message: "Seu cupom foi removido por não atender mais a regra de valor mínimo de pedido."});
        }
      }
    }
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        this.startInatividade();
        this.activeClub();
        this.order = this.getOrderRequest;
        this.chave_pix = this.getChavePix.chave_pix;
        this.loadTimes(this.getSelectedAddress);
        if(this.checkModules(8) == 8){
          this.loadCarteira(0).then(function(){
            this.getWalletValue();
          }.bind(this));
        }
        this.loadCupons().then(function(){
          this.checkCuponsMin();
          this.updateFrete({ "address": this.getSelectedAddress, "express": this.opt_express });
        }.bind(this));
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
    }.bind(this))
    .catch(function (e) {
      this.$router.push("/baixeoapp");
    }.bind(this));
    this.checkLayout();
    window.addEventListener("resize", this.checkLayout);
  },
  unmounted(){
    window.removeEventListener("resize", this.checkLayout);
  }
};
</script>